export default "__VITE_ASSET__82dd3b48__"